import React, { useEffect, useState } from 'react';
import { Message } from 'primereact/message';
import type { AsignarPerfilRespuesta, Perfil, Responsable } from '../../negocio/negocio.types';
import { PerfilesService } from '../services/perfiles.service';
import { ResponsablesService } from '../../responsables/services/responsables.service';
import { mensajeDeError, noDisponible } from '../../negocio/errores';
import { AsignarPerfilForm, CuentaParaPerfil } from './AsignarPerfilForm';

interface Props {
  usuario: CuentaParaPerfil;
  onGuardado?: (r: AsignarPerfilRespuesta) => void;
}

/**
 * Perfil y alcance de Consulta CM dentro de la edición de una cuenta
 * (Usuarios). Como Alcance de Metas, vive FUERA de `UserForm`: se guarda al
 * instante contra otra ruta (`PUT /users/:id/perfil`). Con una API anterior a
 * Consulta CM no se muestra nada.
 */
export const PerfilUsuarioSection: React.FC<Props> = ({ usuario, onGuardado }) => {
  const [perfiles, setPerfiles] = useState<Perfil[] | null>(null);
  const [responsables, setResponsables] = useState<Responsable[]>([]);
  const [sinRuta, setSinRuta] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let vivo = true;
    PerfilesService.listar()
      .then((p) => vivo && setPerfiles(p))
      .catch((e) => {
        if (!vivo) return;
        if (noDisponible(e)) setSinRuta(true);
        else setError(mensajeDeError(e));
      });
    ResponsablesService.listar()
      .then((r) => vivo && setResponsables(r))
      .catch(() => undefined);
    return () => {
      vivo = false;
    };
  }, [usuario.id]);

  if (sinRuta) return null;

  return (
    <section className="space-y-3 border-t border-solid border-gray-200 px-6 py-6">
      <div>
        <h3 className="text-base font-semibold text-gray-900">Consulta CM: perfil y alcance</h3>
        <p className="text-xs text-gray-500">Se guarda al instante, aparte de «Actualizar usuario».</p>
      </div>
      {error && <Message severity="error" text={error} className="w-full justify-start" />}
      {perfiles && (
        <AsignarPerfilForm usuario={usuario} perfiles={perfiles} responsables={responsables} onGuardado={(r) => onGuardado?.(r)} />
      )}
    </section>
  );
};
